<template>
    <select-c class="inline-block" v-model="symbol" :options="options"></select-c>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const props = defineProps({
    label: String,
    symbols: Array,
    defaultSymbol: String,
});

const emit = defineEmits();

const symbol = ref(null);

const options = computed(() => {
    return buildOptions(props.symbols, props.defaultSymbol);
});

watch(symbol, () => {
    emit('update:modelValue', symbol.value);
});

const emitSymbol = () => {
    emit('update:modelValue', symbol.value);
};

const buildOptions = (symbols, defaultSymbol) => {
    return symbols.map((mSymbol) => {
        if (mSymbol.value === defaultSymbol) {
            mSymbol.default = true;
        }
        return mSymbol;
    });
};

onMounted(() => {
    if (props.defaultSymbol) {
        symbol.value = props.defaultSymbol;
    }
    emitSymbol();
});
</script>
